var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEuroTag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    viewBox: "0 0 40 40",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.912 27.25c-3.3-3.292-3.3-6.927 0-10.218 3.29-3.292 6.92-3.292 10.21 0m-10.21-3.405l6.81 6.811m-10.22-3.406l5.11 5.108m11.551-10.898a2.408 2.408 0 100-4.817 2.408 2.408 0 000 4.817z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.922 1h-15.62c-.71 0-1.39.293-1.88.812L1.702 19.597a2.574 2.574 0 00-.7 1.882c.04.696.35 1.347.88 1.804l16.72 14.582c1.04.911 2.62.832 3.57-.18l15.64-16.695c.44-.475.69-1.1.69-1.752V3.567a2.54 2.54 0 00-.76-1.817 2.553 2.553 0 00-1.82-.75z"
  })));
}
export default SvgEuroTag;